import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "./resources/ThemeProvider";
import { RouterProvider } from "react-router-dom";
import appBrowserRouter from "./router/appBrowserRouter";
import { AuthProvider } from "./resources/AuthProvider";
import { setupAppTimezone } from "./utils/timezone";

setupAppTimezone();

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <ThemeProvider>
        <AuthProvider>
          <RouterProvider router={appBrowserRouter} />
        </AuthProvider>
      </ThemeProvider>
    </React.StrictMode>,
  );
} else {
  console.error("Elemento root não encontrado.");
}
